import networkService from "./NetworkService";
import IVisitor from "../models/IVisitor";

class VisitorService {
  
  /**
   * Sends visitor data to the API
   * @param visitor Object containing visitor information
   * @returns Promise with API response
   */
  public async sendVisitor(visitor: IVisitor): Promise<string> {
      
      const result = await networkService.post<IVisitor, string>("/visitor", visitor);
      
      if (result.isSuccessful && result.data) {
        return result.data as string;
      }

      throw result.data;
  }

  /**
   * Sends unsubscribe request to the API
   * @param id The visitor ID to unsubscribe
   * @param user The user ID requesting the unsubscribe
   * @returns Promise with API response
   */
  public async unsubscribe(id: string, user?: string): Promise<string> {
      const result = await networkService.post<void, string>(`/visitor/unsubscribe?id=${id}&user=${user}`, null!);

      if (result.isSuccessful && result.data) {
        return result.data as string;
      }

      throw result.data;
  }

  /**
   * Sends unsubscribe request by email to the API
   * @param email The email address to unsubscribe
   * @returns Promise with API response
   */
  public async unsubscribeByEmail(email: string): Promise<string> {
      const result = await networkService.post<void, string>(`/visitor/unsubscribe-email?email=${encodeURIComponent(email)}`, null!);

      if (result.isSuccessful && result.data) {
        return result.data as string;
      }

      throw result.data;
  }
}

const visitorService = new VisitorService();
export default visitorService;
